import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import { questionnaireItemsActions } from '../../../../core/questionnaire-items/actions';
import LoadingIndicator from "../../../components/loading-indicator/loading-indicator";

export const QuestionnaireDetails = ({ questionnaireId, handleNextSection }) => {
    const dispatch = useDispatch();
    const questionnaire = useSelector(state => state.questionnaire_list?.data);

    useEffect(() => {
        if (questionnaireId) {
            dispatch(questionnaireItemsActions.loadQuestionnaireItems(questionnaireId));
        }
    }, [dispatch, questionnaireId]);

    return (
        <>
        <div className='w-100'>
            <div className='mb-4 pt-md-4 d-flex align-items-center'>
                <Button color='link' className="text-body p-0 mr-3 mb-1" onClick={(event) => handleNextSection('questionnaires_list', event)}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="24" height="20" viewBox="0 0 24 20">
                        <path d="M24,10c0,0.3-0.1,0.5-0.3,0.7C23.5,10.9,23.3,11,23,11H3.4l7.3,7.3c0.1,0.1,0.2,0.2,0.2,0.3
                                        C11,18.7,11,18.9,11,19c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C10.3,20,10.1,20,10,20
                                        c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2l-9-9c-0.1-0.1-0.2-0.2-0.2-0.3C0,10.3,0,10.1,0,10c0-0.1,0-0.3,0.1-0.4
                                        c0.1-0.1,0.1-0.2,0.2-0.3l9-9C9.5,0.1,9.7,0,10,0c0.3,0,0.5,0.1,0.7,0.3C10.9,0.5,11,0.7,11,1c0,0.3-0.1,0.5-0.3,0.7L3.4,9H23
                                        c0.3,0,0.5,0.1,0.7,0.3C23.9,9.5,24,9.7,24,10z"/>
                    </svg>
                </Button>
                <h1 className='libre-caslon-text-regular h3-md h4 mb-0'>{questionnaire?.questionnaire?.name}</h1>
            </div>
            <ul className='questionnaires_questions_list list-unstyled'>
                {questionnaire?.answered_items?.map((item, index) => (
                    <li key={item.id} className='mb-3 border-bottom'>
                        <div className='d-flex align-items-md-start mb-3'>
                            <div className='mr-3'>
                                <div className="rounded-circle question-member bg-border-color text-center font-weight-bold">{index + 1}</div>
                            </div>
                            <div className='flex-fill'>
                                <div className='d-flex align-items-start'>
                                    <div className='flex-fill'>
                                        <h2 className='mb-0 h6 h5-md'>{item.title}</h2>
                                        <p>{item.subtitle}</p>
                                    </div>
                                    <Link to={`/questionnaire/${questionnaireId}`} className="btn btn-outline-green-light btn-sm">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill='currentColor'>
                                            <path d="M12.6,3.9l-2.4-2.4C9.9,1.2,9.7,1.1,9.4,1.1c-0.3,0-0.6,0.1-0.8,0.3L1.9,8.2C1.7,8.3,1.7,8.4,1.6,8.5
                                            C1.6,8.6,1.5,8.8,1.5,8.9v2.4c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3h9.2c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5
                                            c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2h-5l5.8-5.8c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.1,0.1-0.3,0.1-0.4s0-0.3-0.1-0.4
                                            C12.8,4.1,12.7,4,12.6,3.9z M5,11.2H2.8V9l4.6-4.6l2.1,2.1L5,11.2z M10.5,5.6L8.4,3.5l1-1l2.1,2.1L10.5,5.6z"/>
                                        </svg>
                                    </Link>
                                    
                                </div>
                                <ul className='list-unstyled text-muted mb-0'>
                                    {item.selected.map(selectedOption => {
                                        const option = item.options.find(opt => opt.id === selectedOption.option_id);
                                        return (
                                            <li key={selectedOption.option_id}>
                                                <i className='mr-1'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill='currentColor' width="12" height="12" viewBox="0 0 12 12">
                                                        <path d="M10.9,3.8l-6,6C4.8,9.8,4.8,9.9,4.7,9.9s-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1L1.5,7.1
                                                                C1.4,7.1,1.4,7,1.4,7c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0
                                                                c0.1,0,0.1,0.1,0.2,0.1l2.2,2.2L10.1,3c0.1-0.1,0.2-0.2,0.4-0.2c0.1,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.4
                                                                C11.1,3.5,11,3.7,10.9,3.8L10.9,3.8z"/>
                                                    </svg>
                                                </i>{option ? option.title : 'Opción no encontrada'}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
        </>
    );
}